import HomeIcon from "@mui/icons-material/Home";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import Layout from "../components/layout/Layout.component";
import Skeleton from "../components/utils/Skeleton.component";
import { useSonho } from "../services/sonhos";
import {
  ChipFlutuant,
  Lista,
  SonhosRealizadosDetails,
} from "../styles/pages/SonhosRealizadosDetails";

export default function SonhosRealizados() {
  const { data, getSonhos, loading } = useSonho();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    getSonhos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <SonhosRealizadosDetails>
        <div className="content">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "40px",
            }}
          >
            <Breadcrumbs>
              <Link
                underline="hover"
                href="/"
                sx={{ display: "flex", alignItems: "center", color: "black" }}
              >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Home
              </Link>
              <Typography sx={{ color: "text.primary" }}>
                Sonhos Realizados
              </Typography>
            </Breadcrumbs>
            <Typography
              variant="h4"
              sx={{
                maxWidth: "600px",
              }}
            >
              Conheça os sonhos já realizados pela Bellatchau!
            </Typography>
            <Lista>
              {loading ? (
                <>
                  <Skeleton height="412px" style={{ borderRadius: "16px" }} />
                  <Skeleton height="412px" style={{ borderRadius: "16px" }} />
                  <Skeleton height="412px" style={{ borderRadius: "16px" }} />
                  <Skeleton height="412px" style={{ borderRadius: "16px" }} />
                  <Skeleton height="412px" style={{ borderRadius: "16px" }} />
                </>
              ) : (
                <>
                  {data?.map((item) => (
                    <div
                      className="item-list"
                      key={`card-banner-${item.id}`}
                      onClick={() =>
                        navigate(
                          `/sonhos-realizados/${item.title
                            .replace(/ /g, "-")
                            .toLocaleLowerCase()}?id=${item.id}`
                        )
                      }
                    >
                      <ChipFlutuant
                        color="primary"
                        icon={<LocationOnIcon />}
                        label={item.local}
                      />
                      <img
                        src={item.imagesUrl[0]}
                        alt={item.title}
                        className="img-item-list"
                      />
                      <Typography
                        variant="h6"
                        className="typography"
                        p={2}
                        pt={1}
                        m={0}
                      >
                        {item.title}
                      </Typography>
                    </div>
                  ))}
                </>
              )}
            </Lista>
          </Box>
        </div>
      </SonhosRealizadosDetails>
    </Layout>
  );
}
